<template>
  <div class="w-full bg-gray-200 px-2 py-2 rounded-md">
    <button v-if="!extended" @click="extended = !extended">
      Extend flag information ({{ history.length }} comments)
    </button>
    <div class="flex flex-col relative" v-else>
      <button
        class="absolute top-2 right-2 w-6 h-6"
        @click="extended = !extended"
      >
        <img src="@/assets/icons/exit.svg" alt="Close" />
      </button>
      <h2>Order flag data</h2>
      <p v-if="history.length == 0" class="my-2 text-red-400 font-bold">
        No flags registered
      </p>
      <div v-else class="flex flex-col gap-2 mt-4">
        <div
          v-for="flag in history"
          :key="flag.uuid"
          class="bg-gray-300 p-2 rounded-md"
        >
          <p class="flex flex-row">
            <b>{{ flag.name }} ({{ flag.createdAt | dateWithHours }})</b>
            <span v-if="flag.flag == 1">
              <img
                class="w-4 h-4 ml-4 flex-shrink-0"
                src="img/api/menu-icons/flag.svg"
                alt="flag"
              />
            </span>
            <span v-else>
              <img
                class="w-4 h-4 ml-4 flex-shrink-0"
                src="img/api/menu-icons/flag-green.svg"
                alt="flag"
              />
            </span>
          </p>
          <p>{{ flag.comment }}</p>
        </div>
      </div>
      <div class="flex flex-col mt-2">
        <form @submit.prevent="createFlag">
          <textarea
            placeholder="Flag comment"
            v-model="comment"
            class="p-2 w-full"
          ></textarea>
          <button class="dark-button mt-2 flex w-min whitespace-nowrap">
            Add comment
          </button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { createOrderFlag } from "@/api/Orders";
export default {
  name: "OrderFlagData",
  props: {
    orderUUID: {
      type: String,
      required: true
    },
    history: {
      type: Array,
      required: true
    },
    flag: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      extended: false,
      comment: ""
    };
  },
  methods: {
    createFlag() {
      createOrderFlag(this.orderUUID, this.flag, this.comment)
        .then(() => {
          this.$emit("flagAdded");
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.comment = "";
        });
    }
  }
};
</script>
